import { STATUSES } from '@/constants/statuses'

export const DEFAULT_ORDERS_COUNT_PER_PAGE = 20

export const PER_PAGE_ORDER_OPTIONS = [10, 20, 30, 40, 50]

export const CLICK_DELAY = 200
export const DEBOUNCE_DELAY = 400

export const API_TO_FIELD_MAP = {
    num: 'orderNumber',
    address: 'address',
    price_min: 'amount',
}

export const ALLOWED_PRINT_TEMPLATE_IDS = {
    KITCHEN_TICKET: 'ticket',
    INVOICE: 'invoice',
    FISCAL: 'fiscal',
    THERMO: 'thermo',
}

export const FORBIDDEN_CHANGE_STATUSES = [
    STATUSES.COLLECTED,
    STATUSES.COMPLETED,
    STATUSES.SENT_TO_DIVISION,
    STATUSES.SEND_ERROR,
    STATUSES.CANCELED_BY_MANAGER,
    STATUSES.CANCELED,
]

export const FORBIDDEN_STATUSES_FOR_PICKUP = [
    STATUSES.ON_THE_WAY,
    STATUSES.DELIVERED,
]

export const FORBIDDEN_STATUSES_FOR_PREORDER = FORBIDDEN_STATUSES_FOR_PICKUP

export const ORDER_STATUSES_MAP = {
    [STATUSES.WAITING_START_COOKING]: [STATUSES.COOKING],
    [STATUSES.COOKING]: [STATUSES.COLLECTED],
    [STATUSES.COLLECTED]: [STATUSES.COMPLETED],
    [STATUSES.ON_THE_WAY]: [STATUSES.DELIVERED, STATUSES.COMPLETED],
    [STATUSES.DELIVERED]: [STATUSES.COMPLETED],
}

export const FORBIDDEN_STATUSES_FOR_STAFF = [
    STATUSES.COLLECTED,
    STATUSES.ON_THE_WAY,
    STATUSES.DELIVERED,
]

export const STAFF_ORDER_STATUSES_MAP = {
    [STATUSES.COOKING]: [STATUSES.COMPLETED],
}
